
import React from "react";
import { UseFormRegister } from "react-hook-form";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { CourseFormData } from "../types";

interface DescriptionFieldProps {
  register: UseFormRegister<CourseFormData>;
}

export function DescriptionField({ register }: DescriptionFieldProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="description">Description (Optional)</Label>
      <Textarea
        id="description"
        {...register("description")}
        className="min-h-[120px]"
      />
    </div>
  );
}
